import { FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { memo, useCallback } from "react";
import { useFormContext } from "react-hook-form";
import { type ChildrenSelectorProps } from "./types";

export const ChildrenSelector = memo(function ChildrenSelector({ day, period }: ChildrenSelectorProps) {
  const form = useFormContext();

  const fieldName = `openingHours.${day}.${period}.maxChildren`;

  const handleValueChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      if (value === "") {
        // Permettre un champ vide temporairement
        form.setValue(fieldName, "", { shouldValidate: false });
      } else {
        const numValue = parseInt(value);
        if (!isNaN(numValue)) {
          // Limiter à 999 maximum, mais pas de minimum pendant la saisie
          const clampedValue = Math.min(numValue, 999);
          form.setValue(fieldName, clampedValue, { shouldValidate: false });
        }
      }
    },
    [form, fieldName]
  );

  const handleBlur = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      const value = e.target.value;
      if (value === "" || parseInt(value) < 1) {
        // Si vide ou < 1, mettre 1 par défaut quand on quitte le champ
        form.setValue(fieldName, 1, { shouldValidate: true });
      } else {
        // Valider le champ quand on le quitte
        form.trigger(fieldName);
      }
    },
    [form, fieldName]
  );

  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field, fieldState }) => (
        <div className="flex flex-col space-y-2">
          <div className={cn("text-sm font-medium text-gray-700", fieldState.invalid && "text-destructive")}>Enfants max</div>
          <FormItem>
            <FormControl>
              <Input
                type="number"
                min="1"
                max="999"
                value={field.value}
                onChange={handleValueChange}
                onBlur={handleBlur}
                className="h-10 w-full border-gray-200 bg-white"
                placeholder="Ex: 25"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        </div>
      )}
    />
  );
});
